import { reatomAsync, withDataAtom } from "@reatom/async"
import { onConnect } from "@reatom/hooks"

import { fetchCities } from "modules/PsyCatalog/common/Filters/api"

export const citiesFetcher = reatomAsync(fetchCities, "fetchCities").pipe(withDataAtom([]))
onConnect(citiesFetcher.dataAtom, citiesFetcher)
